import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/context/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';

const aboutContent = {
  ru: {
    historyTitle: 'О нас',
    history: `Государственное коммунальное казённое предприятие «Спортивный медицинский центр города Астаны» акимата города Астаны является специализированным медицинским учреждением, осуществляющим квалифицированное медицинское обслуживание спортсменов, находящихся в ведении Управления спорта города Астаны.

Центр создан в 2021 году с целью развития системы спортивной медицины и обеспечения комплексного медико-биологического сопровождения спортсменов на всех этапах спортивной подготовки.

Основными направлениями деятельности Центра являются:
– проведение углубленных, текущих и этапных обследований спортсменов сборных команд и учащихся специализированных школ олимпийского резерва города Астаны, а также иным лицам, занимающимся физической культурой и спортом, в том числе лиц с ограниченными возможностями;
– проведение диспансерного наблюдения спортсменов сборных команд и учащихся специализированных школ олимпийского резерва города Астаны, а также иным лицам, занимающимся физической культурой и спортом, в том числе лиц с ограниченными возможностями;
– разработка и реализация программ профилактики, восстановления и реабилитации спортсменов и лиц, занимающихся физической культурой, в том числе лиц с ограниченными возможностями;
– медицинское сопровождение и фармакологическое обеспечение спортивных мероприятий различного уровня;
– проведение санитарно-просветительской работы среди спортсменов, тренеров и родителей;
– мониторинг состояния здоровья и предупреждение профессиональных заболеваний;
– проведение комплексного функционального тестирования спортсменов сборных команд и учащихся специализированных школ олимпийского резерва города Астаны, а также иным лицам, занимающимся физической культурой и спортом, в том числе лиц с ограниченными возможностями;
– оказание лабораторных исследований для спортсменов сборных команд и учащихся специализированных школ олимпийского резерва города Астаны, а также иным лицам, занимающимся физической культурой и спортом, в том числе лиц с ограниченными возможностями;
– оказание лечебно-профилактических и реабилитационных услуг спортсменам сборных команд и учащимся специализированных школ олимпийского резерва города Астаны, а также иным лицам, занимающимся физической культурой и спортом, в том числе лиц с ограниченными возможностями;

Центр осуществляет медицинское сопровождение спортсменов всех уровней квалификации — от начинающих спортсменов детско-юношеских спортивных школ до членов национальных сборных команд. 
Медицинскую деятельность осуществляет команда высококвалифицированных специалистов, обладающих значительным опытом сопровождения спортсменов на международных соревнованиях, чемпионатах мира, Азии и Олимпийских играх.`,
    goalTitle: 'Цель Центра',
    goal: `Целью Центра является обеспечение профессионального медицинского сопровождения спортсменов, соответствующего международным стандартам качества, и расширение спектра оказываемых медицинских услуг. В перспективе Центр нацелен на предоставление медицинской помощи не только подведомственному контингенту, но и всем заинтересованным лицам — гражданам, ведущим активный образ жизни, а также любителям и профессионалам спорта.

Центр стремится к созданию медицинской системы, сопоставимой с лучшими мировыми практиками, обеспечивая доступ к современным технологиям и методам в области спортивной медицины и реабилитации.`,
    missionTitle: 'Миссия Центра',
    mission: `Обеспечение полного цикла медицинского сопровождения спортсменов — от диагностики и профилактики до восстановления, в соответствии с лучшими мировыми практиками. Мы создаём условия для безопасного и эффективного достижения спортивных результатов.

Мы обеспечиваем всё лучшее — для здоровья, безопасности и спортивного будущего наших спортсменов.`,
    decorBlock: [
      'Индивидуальный подход к каждому пациенту',
      'Только современные и безопасные методы лечения',
      'Комплексная диагностика и сопровождение на всех этапах восстановления',
    ]
  },
  kz: {
    historyTitle: 'Біз туралы',
    history: `«Астана қаласы әкімдігінің Спорттық медицина орталығы» мемлекеттік коммуналдық қазыналық кәсіпорны – Астана қаласы Спорт басқармасының қарамағындағы, спортшыларға кәсіби медициналық қызмет көрсететін мамандандырылған мекеме.
  
  Орталық 2021 жылы спорттық медицина жүйесін дамыту және спортшыларды спорттық дайындықтың барлық кезеңінде кешенді медициналық-биологиялық сүйемелдеумен қамтамасыз ету мақсатында құрылған.
  
  Орталықтың негізгі қызмет бағыттары:
  – Астана қаласының құрама командалары мен олимпиадалық резервтің мамандандырылған мектептерінің спортшыларын, сондай-ақ дене шынықтыру және спортпен айналысатын өзге тұлғаларды (соның ішінде мүмкіндігі шектеулі адамдарды) тереңдетілген, ағымдағы және кезеңдік медициналық тексеруден өткізу;
  – Аталған тұлғаларды диспансерлік бақылауға алу;
  – Алдын алу, қалпына келтіру және оңалту бағдарламаларын әзірлеп, іске асыру;
  – Спорттық іс-шараларды медициналық және фармакологиялық қамтамасыз ету;
  – Спортшылар, жаттықтырушылар және ата-аналар арасында санитарлық-ағартушылық жұмыс жүргізу;
  – Денсаулық жағдайын бақылау және кәсіби аурулардың алдын алу;
  – Кешенді функционалдық тестілеу жүргізу;
  – Зертханалық зерттеулер жүргізу;
  – Емдеу-профилактикалық және оңалту қызметтерін көрсету.
  
  Орталық балалар мен жасөспірімдер спорт мектептерінен бастап ұлттық құрама командалардың мүшелеріне дейінгі барлық деңгейдегі спортшыларға медициналық қолдау көрсетеді. Медициналық қызметтерді халықаралық жарыстарда, әлем және Азия чемпионаттарында, Олимпиада ойындарында спортшыларды сүйемелдеу тәжірибесі бар жоғары білікті мамандар ұжымы атқарады.`,
  
    goalTitle: 'Орталықтың мақсаты',
    goal: `Орталықтың басты мақсаты – спортшыларға халықаралық сапа стандарттарына сәйкес кәсіби медициналық қолдау көрсету және ұсынылатын медициналық қызметтер спектрін кеңейту. Алдағы уақытта Орталық тек бағынышты контингентке ғана емес, сонымен қатар белсенді өмір салтын ұстанатын азаматтарға, спортпен айналысатын және кәсіби деңгейде шұғылданатын барлық мүдделі тұлғаларға да медициналық көмек көрсетуді көздейді.
  
  Орталық спорттық медицина мен оңалту саласындағы заманауи технологиялар мен әдістерді қолдана отырып, әлемдік үздік тәжірибелерге сай келетін жоғары сапалы медициналық жүйе құруға ұмтылады.`,
  
    missionTitle: 'Орталықтың миссиясы',
    mission: `Диагностикадан бастап алдын алуға және қалпына келтіруге дейінгі барлық кезеңдерде спортшыларға әлемдік үздік тәжірибелерге негізделген толық медициналық сүйемелдеуді қамтамасыз ету. Біз спорттық жетістіктерге қауіпсіз әрі тиімді жолмен жету үшін қажетті жағдай жасаймыз.
  
  Спортшыларымыздың денсаулығы, қауіпсіздігі және болашағы – біздің басты құндылықтарымыз.`,
  
    decorBlock: [
      'Әрбір пациентке жеке көзқарас',
      'Заманауи және қауіпсіз емдеу әдістері',
      'Диагностика мен оңалтудың барлық кезеңдерінде толық қолдау',
    ]
  }
  
};

const AboutFull: React.FC = () => {
  const { language } = useLanguage();
  const lang = language as "ru" | "kz";

  return (
    <>
      <Header />
      <section className="py-8 md:py-16 bg-gov-light-blue min-h-screen section-padding animate-fade-in">
        <div className="container mx-auto px-4">
          <h1 className="text-2xl md:text-4xl font-serif font-bold text-gov-dark-blue mb-6 md:mb-10 text-center">
            {aboutContent[lang].historyTitle}
          </h1>
          
          {/* History Section */}
          <div className="max-w-3xl mx-auto mb-8 md:mb-12">
            <p className="text-gray-700 text-base md:text-lg bg-white/70 p-4 md:p-6 rounded-lg shadow-md leading-relaxed whitespace-pre-line">
              {aboutContent[lang].history}
            </p>
          </div>
          
          {/* Separator */}
          <div className="max-w-3xl mx-auto my-8 md:my-12 flex items-center">
            <hr className="flex-grow border-t border-gray-400" />
            <span className="px-3 md:px-4 text-xl md:text-2xl text-gray-600">⸻</span>
            <hr className="flex-grow border-t border-gray-400" />
          </div>
          
          {/* Goal Section */}
          <div className="max-w-3xl mx-auto mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-serif font-bold mb-3 md:mb-4 text-gov-blue">{aboutContent[lang].goalTitle}</h2>
            <p className="text-gray-700 text-base md:text-lg bg-white/70 p-4 md:p-6 rounded-lg shadow-md leading-relaxed whitespace-pre-line">
              {aboutContent[lang].goal}
            </p>
          </div>
          
          {/* Separator */}
          <div className="max-w-3xl mx-auto my-8 md:my-12 flex items-center">
            <hr className="flex-grow border-t border-gray-400" />
            <span className="px-3 md:px-4 text-xl md:text-2xl text-gray-600">⸻</span>
            <hr className="flex-grow border-t border-gray-400" />
          </div>
          
          {/* Mission Section */}
          <div className="max-w-3xl mx-auto mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-serif font-bold mb-3 md:mb-4 text-gov-blue">{aboutContent[lang].missionTitle}</h2>
            <p className="text-gray-700 text-base md:text-lg bg-white/70 p-4 md:p-6 rounded-lg shadow-md leading-relaxed whitespace-pre-line">
              {aboutContent[lang].mission}
            </p>
          </div>
          
          <div className="max-w-2xl mx-auto mb-8 md:mb-12 bg-white/80 p-4 md:p-6 rounded-lg">
            <ul className="list-disc text-base md:text-lg pl-4 space-y-1 md:space-y-2 text-gov-blue">
              {aboutContent[lang].decorBlock.map((v, i) => (
                <li key={i}>{v}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AboutFull;

